export const paths = [{ "tag": "path", "att": { "d": "m9.4206 7.5015 1.8217-1.8217-1.4142-1.4142-4.2426 4.2427 4.2426 4.2426 1.4142-1.4142-1.8352-1.8352H12c2.2092 0 4 1.7909 4 4 0 2.2092-1.7908 4-4 4v2c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6H9.4206z" } }];
export const iconName = 'arrow-u-turn-backwards';
export const arrowUTurnBackwards = { iconName, paths };
export default paths;
